import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    { path: '/', component: () => import('views/index') },
    {
      path: '/news', component: () => import('views/news/index'), children: [
         {path: '/', component: () => import('views/news/list') },
        { path: 'detail', component: () => import('views/news/detail') },
      ]
    },
    {
      path: '/about', component: () => import('views/about/index'), children: [
        { path: 'detail', component: () => import('views/news/detail') },
      ]
    },
    {
      path: '/product', component: () => import('views/product/index'), children: [
        { path: '/', component: () => import('views/product/list') },
        { path: 'detail', component: () => import('views/product/detail') },
      ]
    },
    { path: '/industry', component: () => import('views/industry/index') },
    { path: '/service', component: () => import('views/service/index') },
    { path: '/partner', component: () => import('views/partner/index') },
    {
      path: '/recruit', component: () => import('views/recruit/index'), children: [
         {path: '/', component: () => import('views/recruit/list') },
        { path: 'detail', component: () => import('views/recruit/detail') },
      ]
    },
    { path: '/contact', component: () => import('views/contact/index') },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js